import React, {useState/*, useContext */ } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

function SubscribeStage(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    // console.warn('stato di props.registrationInfo: ', props.registrationInfo);

    function toggleModal() {
        // console.warn('arrivato a toggle!!');
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    function onUnsubscribe() {
        console.warn('deregistrazione da fare');
    }
    
    async function onFinish(values) {
        values.stageId = props.stageId
        // console.warn('values della form: ', values)
        
        props.onSubscribe.mutate(values)
        setIsActive(false);
        // window.location.reload(false)
    }

    // console.warn(props.registrationInfo);
    if (props.registrationInfo.registered === true && props.registrationInfo.info.length > 0) {
        return (
            <div>
                <Modal title="Update Registration" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} cancelText="Cancel" okText="Update">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{"id": props.registrationInfo.info[0].deckId, "deckName": props.registrationInfo.info[0].deckName, "TxtDeckList": props.registrationInfo.info[0].txtDeckList, "deckLink": props.registrationInfo.info[0].deckLink }}>
                        <Form.Item label="Deck Name" name="deckName" rules={[{ required: true, message: 'Please insert your deck \'s name!' }]}>
                            <Input placeholder="Deck Name" />
                        </Form.Item>
                        <Form.Item label="Decklist" name="TxtDeckList" tooltip={{ title: 'Insert decklist in txt format, as shown here: <nr copies> <card name in english>', icon: <InfoCircleOutlined /> }}>
                            <Input.TextArea rows={20} placeholder="Decklist" />
                        </Form.Item>
                        <Form.Item label="Link" name="deckLink" tooltip={{ title: 'If you have mtggoldfish or moxfield link, paste here.', icon:  <InfoCircleOutlined /> }}>
                            <Input placeholder="Link Decklist" />
                        </Form.Item>
                        <Form.Item hidden name="id" />
                    </Form>
                </Modal>
                <Button style={{ marginTop: 16, marginRight: 16 }} type="primary" onClick={toggleModal}>
                    UPDATE REGISTRATION
                </Button>
                {/* <Button danger type="primary" onClick={onUnsubscribe}>DELETE REGISTRATION</Button> */}
            </div>
        );
    }
    return(
            <div>
                <Modal title="Register to Stage" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} cancelText="Cancel" okText="Register">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }}>
                        <Form.Item label="Deck Name" name="deckName" rules={[{ required: true, message: 'Please insert your deck \'s name!' }]}>
                            <Input placeholder="Deck Name" />
                        </Form.Item>
                        <Form.Item label="Decklist" name="TxtDeckList" tooltip={{ title: 'Insert decklist in txt format, as shown here: <nr copies> <card name in english>', icon: <InfoCircleOutlined /> }}>
                            <Input.TextArea rows={20} placeholder="Decklist" />
                        </Form.Item>
                        <Form.Item label="Link" name="deckLink" tooltip={{ title: 'If you have mtggoldfish or moxfield link, paste here.', icon:  <InfoCircleOutlined /> }}>
                            <Input placeholder="Link Decklist" />
                        </Form.Item>
                    </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    REGISTER
                </Button>
            </div>
    )
}

export default SubscribeStage;